import request from "@assets/js/axios";
const {
  instance: $axios
} = request;
class OrderPro {
  constructor() {}
  // 获取(其他)下拉分类列表
  getVisaFees() {
    return $axios.get('/api/v2/home/visCache');
  }
  // 获取订单相关的基础数据
  getOrderBaseData() {
    return $axios.get('/api/xorder/getBaseData');
  }

  // 添加订单
  getOrderList(data) {
    return $axios.get("/api/xorder/list", {
      params: data
    });
  }
  // 通过ID获取订单详情
  getOrderDetailByOrdersn(order_sn) {
    return $axios.get("/api/xorder/detail?order_sn=" + order_sn);
    return $axios.get("/api/xorder/detail?order_sn=" + order_sn);
  }
  // 通过 订单号 取消订单
  // postData: {
  //   order_sn: '...',
  //   reason: '...'
  // }
  cancelOrderByOrderSn(postData) {
    return $axios.get("/api/xorder/cancel", {
      params: postData
    })
  }
  // 获取下单办理表单数据信息2025-03-26
  getOrderFieldOptions(sku_id) {
    return $axios.get('/apiv1/goods/visa/getVisaOrderFieldOptions?sku_id=' + sku_id);
  }
  // 更新办理表单信息 2025-03-26
  updateOrderExtra(updateForm) {
    return $axios.post('/api/xorder/updateOrderExtra', updateForm);
  }

  // 获取工具toolstoken
  getToolsToken() {
    return $axios.get("/api/v2/tools/getToken");
  }
}

export default new OrderPro();